module.exports = __webpack_public_path__ + "static/media/errorIcon.936c1dc5.svg";